import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Autocomplete, SelectOption } from '@recargas-dominicanas/core/components';
import { type Field, formatCurrency, formatDate } from '@recargas-dominicanas/core/utils';
import { type ILinkedTransaction } from '@recargas-dominicanas/core/types';
import { BankAccountApi } from '@recargas-dominicanas/core/api';
import { style } from './linked-transaction-select.module.css';

interface Props {
  className?: string;
  label?: string;
  icon: string;
  placeholder: string;
  bankAccountId: number;
  filter: 'deposit' | 'withdrawal';
  field: Field<string>;
}

export function LinkedTransactionSelect(props: Props) {

  const {
    className,
    label,
    icon,
    placeholder, 
    bankAccountId,
    filter,
    field 
  } = props;

  const [linkedTransactions, setLinkedTransactions] = useState<(ILinkedTransaction)[]>();

  useEffect(() => {
    fetch();
  }, []);

  function handleSearch(value?: string) {
    fetch(value);
  }

  async function fetch(value?: string) {

    const balance = value ? parseInt(value) : undefined;
    const type = filter === 'deposit' ? 'deposits' : 'withdrawals';

    const linkedTransactions = await BankAccountApi.getLinkedTransactions(bankAccountId, type, { 
      page: 1, 
      size: 30,
      balance 
    });

    setLinkedTransactions(linkedTransactions);
  }

  return (
    <Autocomplete
      style={{ 
        ...style.autocomplete, 
        container: `${style.autocomplete.container} ${className}` 
      }}
      label={label}
      icon={icon}
      placeholder={placeholder}
      formField={field}
      onSearch={handleSearch}>
      { 
        linkedTransactions?.map(linkedTransaction => (
          <SelectOption 
            key={linkedTransaction.id}
            value={linkedTransaction.id}
            label={formatCurrency(linkedTransaction.balance)}
            disabled={linkedTransaction.linked}>
            <div 
              className={clsx(style.item, linkedTransaction.linked && style.disabled)}>
              <span
                className={clsx(style.balance, linkedTransaction.linked && style.disabled)}>
                {formatCurrency(linkedTransaction.balance)}
              </span>
              <span 
                className={clsx(style.date, linkedTransaction.linked && style.disabled)}>
                {formatDate(linkedTransaction.date)}
              </span>
            </div>
          </SelectOption>
        ))
      }
    </Autocomplete>
  );
}
